import { render, staticRenderFns } from "./RemoveItemModal.vue?vue&type=template&id=d765ce18&"
import script from "./RemoveItemModal.vue?vue&type=script&lang=js&"
export * from "./RemoveItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d765ce18')) {
      api.createRecord('d765ce18', component.options)
    } else {
      api.reload('d765ce18', component.options)
    }
    module.hot.accept("./RemoveItemModal.vue?vue&type=template&id=d765ce18&", function () {
      api.rerender('d765ce18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/profile/list/components/RemoveItemModal.vue"
export default component.exports